module.exports = __webpack_public_path__ + "img/robinsonr.2da088fa.jpg";